import { LOCALE_TYPE } from 'src/types/locale';

export const getDiscountRateByLocale = (locale: string | undefined) => {
  const discountRate = parseInt(process.env.NEXT_PUBLIC_MEDICINE_DISCOUNT_RATE || '0', 10);

  switch (locale) {
    case LOCALE_TYPE.TW:
    case LOCALE_TYPE.HK:
    case LOCALE_TYPE.CN:
      const percentagePaid = 100 - discountRate;
      if (percentagePaid % 10 === 0) {
        return percentagePaid / 10;
      }
      return percentagePaid;
    default:
      return discountRate;
  }
};
